// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._12l21b66{margin-inline-end:var(--ds-space-050,4px)}\n._12l2r5cr{margin-inline-end:var(--ds-space-negative-050,-4px)}\n._1e0c1txw{display:flex}\n._1pfhze3t{margin-block-start:var(--ds-space-0,0)}\n._2lx21sbv{flex-direction:row-reverse}\n._4t3i1wug{height:auto}\n._6rthze3t{margin-block-end:var(--ds-space-0,0)}\n._ahbq1b66{margin-inline-start:var(--ds-space-050,4px)}\n._ahbqr5cr{margin-inline-start:var(--ds-space-negative-050,-4px)}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
